var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',[_c('mars-view',{staticClass:"consult-form-content-img icon iconfont",class:_vm.showFull ? 'full' : '',nativeOn:{"click":function($event){$event.stopPropagation();return _vm.chooseImg.apply(null, arguments)}}},[_vm._v("")]),(_vm.uploadProcess > 0 && _vm.uploadProcess < 99)?_c('mars-view',[_vm._v("loading")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }